import { useSetRecoilState } from "recoil";
import { questionsAtom } from "../miscellaneous/questionsAtom";

export const useSetTaskQuestionsState = () => {
  return useSetRecoilState(questionsAtom);
};
